import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { EVENT_COLOR_HEX_BY_ID } from '@app/admin/statistics/forecast/forecast.constant';
import { ForecastCalendarItem } from '@app/admin/statistics/forecast/model/forecast.model';

@Component({
  selector: 'flow-forecast-item',
  templateUrl: './forecast-item.component.html',
  styleUrls: ['./forecast-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForecastItemComponent { 
  @Input() item: ForecastCalendarItem;
  @Input() pastDay: boolean = false;
  eventColorHexById = EVENT_COLOR_HEX_BY_ID;
}
